<template>
  <div class="left-tree content-panel">
    <div class="example">
      <a-spin :spinning="loading">
        <a-tree
          style="height:100%"
          :treeData="treeList"
          :draggable="true"
          @select="select"
          :selectedKeys="selectedKeys"
        >
          <template slot="custom" slot-scope="role">
            <a-tooltip placement="topLeft" :title="role.name">
              <span>{{ role.name }}</span>
            </a-tooltip>
          </template>
        </a-tree>
      </a-spin>
    </div>

  </div>
</template>

<script>
import { getSapDeptList } from '@/api/relevant'
export default {
  mounted () {
    // 获取树
    this.initRoleList()
  },
  data () {
    return {
      searchName: '',
      loading: false,
      treeList: [],
      selectedKeys: []
    }
  },
  methods: {
    // 获取侧边栏数据
    async initRoleList () {
      this.loading = true
      // 调用接口
      const params = {}
      if (this.searchName) {
        params.subcompanyname = this.searchName.trim()
      }
      const res = await getSapDeptList(params)
      if (res && res.status === 0) {
        const loop = data => {
          for (let i = 0; i < data.length; i++) {
            // do
            data[i].key = data[i].code
            data[i].scopedSlots = {
              title: 'custom'
            }
            if (data[i].children) {
              loop(data[i].children)
            }
          }
        }
        loop(res.data.gkbmList)
        this.treeList = res.data.gkbmList
        this.selectedKeys = this.treeList.length
          ? [this.treeList[0].key]
          : []
        console.log(this.treeList)
      } else {
        this.$message.error(res.info.data)
      }
      this.loading = false
      this.getRoleManage()
    },
    // 获取初始右侧展示数据
    getRoleManage () {
      if (this.treeList.length) {
        this.$store.commit('setSapSatus', {
          code: this.treeList[0].code,
          uniqueValue: (new Date()).getTime()
        })
      }
    },
    // 选择一个字典
    select (selectedKeys, info) {
      if (selectedKeys.length === 0) {
        selectedKeys.push(info.node.eventKey)
      }
      this.selectedKeys = selectedKeys
      // console.log('节点信息：', info)
      console.log('选中信息：', this.selectedKeys)
      this.$store.commit('setSapSatus', {
        code: info.node.$vnode.data.props.code
      })
    }
  }
}
</script>

<style lang="less">
.left-tree.content-panel{
  .ant-tree-treenode-selected {
    background: #e6f7ff;
  }

  .ant-tree li{
    position: relative;
    padding: 4px 0 0 !important;
    margin-bottom: 8px !important;

    .ant-tree-node-content-wrapper.ant-tree-node-selected {
      background: transparent;
    }
    .ant-tree-node-content-wrapper:hover {
      background: transparent;
    }

    .ant-tree-child-tree {
      background: #fff;
      margin-top: 8px !important;
    }

    .ant-tree-switcher{
      margin: 0;
    }
    .ant-tree-node-content-wrapper{
      height: 100% !important;
      width: calc(100% - 24px) !important;

      .ant-tree-title{
        display: flex;
        justify-content: space-between;
        width: 100% !important;

        >span{
          display: inline-block !important;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .icon-panel{
          .anticon-plus,
          .anticon-setting,
          .anticon-edit,
          .anticon-delete {
            margin-left: 5px;
            color: #1890ff;
          }
        }
      }
    }
  }
  .ant-tree-treenode-switcher-close{
    height: 32px !important;
  }
  .ant-tree-treenode-switcher-open{
    min-height: 32px !important;
  }
  .ant-tree > li:first-child {
    padding-top: 4px !important;
  }
  .ant-tree > li:last-child {
    padding-bottom: 0 !important;
  }
  .ant-tree-child-tree > li:first-child {
    padding-top: 4px !important;
  }
}
</style>
